import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import {useEffect, useState} from "react";
import {GetConfigByName} from "../../../reduxToolkit/authentication/AuthenticatonApi";
import {SYSTEM_CONFIG_LIST} from "../../Dashboard/Setting/Model/SettingConfigModel";
import {useDispatch} from "react-redux";
import copy from "copy-to-clipboard";
import routes from "../../../Routes/routes";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 * CopyBuildingLinkApp
 *
 * }}
 */

const CopyBuildingLinkApp = ({ itemSelected, userSelected, setShow, setItemSelected, setSelectedList }) => {
    const dispatch = useDispatch(); // Redux dispatch function
    const { t } = useTranslation(); // Translation hook for multilingual support
    const [buttonText, setButtonText] = useState("click_to_copy"); // Button label state
    const [copySecret, setCopySecret] = useState(false);
    const [link, setLink] = useState(""); // Registration link state

    useEffect(() => {
        dispatch(GetConfigByName(SYSTEM_CONFIG_LIST.environmentUrl)).then(({ payload: { data: { data } } }) => {
            // The link copied for one resident carries their apartment and their
            // user, the owner is validated with those two and the building is
            // resolved by the service. The link of the whole building, the one
            // that goes through the identify you form, only carries the building
            const path = userSelected?.userId && userSelected?.buildingApartmentId
                ? `${userSelected.buildingApartmentId}/${userSelected.userId}`
                : `${itemSelected?.id}`;

            setLink(`${data}${routes.buildingRegistration.qr}${path}`);
        });
    }, []);

    /**
     * Builds the full registration message to be copied to the clipboard.
     *
     * Injects the building data into the multilingual message, the apartment is
     * only named when the link was copied for a user that has one assigned.
     *
     * @returns {string} Fully formatted registration message ready to be copied.
     */
    const buildCopyMessage = () => {
        const apartment = userSelected?.apartment;

        return t(apartment ? 'building_registration_copy_message_with_apartment' : 'building_registration_copy_message', {
            buildingName: `${itemSelected?.name}`,
            apartment: `${apartment}`,
            registrationLink: `${link}`,
            interpolation: { escapeValue: false },
        });
    };

    /**
     * Handles copying the registration link to the clipboard.
     * If already copied, hides the modal and triggers the onHide callback.
     */
    const handleConfirm = () => {
        if (copySecret) {
            setCopySecret(false);
            setShow(false);
            if (setItemSelected) setItemSelected(null);
            if (setSelectedList) setSelectedList([]);
            return;
        }
        const fullMessage = buildCopyMessage();
        const success = copy(fullMessage);
        if(success){
            toast.success(t("text_copied_successfully"));
            setButtonText("close")
            setCopySecret(true);
        }else{
            toast.success(t("failed_to_copy_text"));
        }
    }

    /**
     * Hides the modal and resets relevant state.
     */
    const onHideModal = () => {
        setShow(false);
        setCopySecret(false);
        setButtonText("click_to_copy");
        if (setItemSelected) setItemSelected(null);
        if (setSelectedList) setSelectedList([]);
    }

    // Return functions and states to be used by the component
    return {
        t,
        buttonText,
        link,
        handleConfirm,
        onHideModal
    }
}

export default CopyBuildingLinkApp;
